import React, { useEffect, useState } from "react";
import TableLoading from "components/preloader/TableLoading";
import Somethingwentwrong from "pages/Somethingwentwrong";
import NetworkError from "pages/NetworkError"; 

const DataWrapper = ({ loading, error, status, children }) => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOffline(false);
    const handleOffline = () => setOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (loading) return <TableLoading row={12} col={6} width={190} height={20} />;
  if (offline) return <NetworkError />;
  if (error || status === false || status === undefined)
    return <Somethingwentwrong title="Something went wrong, please try again later." />;

  return <>{children}</>;
};

export default DataWrapper;
